import { InteractivityChecker } from '@angular/cdk/a11y';
import { Injectable } from '@angular/core';

@Injectable()
export class A11yService {
  constructor(private interactivityChecker: InteractivityChecker) {}

  /**
   * Focus on the element with the given elementId if it is tabbable.
   * Otherwise, focus on the first tabbable element within the element with the given elementId.
   * @param elementId string id of the element which we want to move focus within
   * @returns void
   */
  public moveFocusToElement(elementId: string): void {
    const element: HTMLElement = document.getElementById(elementId);

    if (this.isElementFocusableAndTabbable(element)) {
      element.focus();
    } else {
      this.moveFocusToFirstTabbableElement(element);
    }
  }

  /**
   * Find the first tabbable element within the provided element and move focus to it.
   * @param element HTMLElement of the container element which we want to move focus within
   * @returns void
   */
  private moveFocusToFirstTabbableElement(element: HTMLElement): void {
    const allElements = Array.from(element.getElementsByTagName('*'));

    const firstTabbableElement = allElements?.find(
      (element) =>
        element instanceof HTMLElement &&
        this.isElementFocusableAndTabbable(element) &&
        element?.offsetParent !== null
    );

    if (!firstTabbableElement) {
      return;
    }

    (firstTabbableElement as HTMLElement)?.focus();
  }

  /**
   * Is the element focusable and tabbable
   * @param element HTMLElement to check for isFocusable and isTabbable
   * @returns boolean
   */
  private isElementFocusableAndTabbable(element: HTMLElement): boolean {
    return (
      this.interactivityChecker.isFocusable(element) &&
      this.interactivityChecker.isTabbable(element)
    );
  }
}
